//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from "@/models";
import { mapGetters } from 'vuex'

export default {
  name: "postBottomBar",
  created() {},
  props: ["liked", "post"],
  data() {
    return {};
  },
  methods: {
    comment: function() {
      if (!this.user) {
        this.$router.push({
          name: "logInSelection",
          query: { from: this.$route.path }
        });
        return;
      }

      this.$emit("comment");
    },

    toggleLike: function() {
      if (!this.user) {
        this.$router.push({
          name: "logInSelection",
          query: { from: this.$route.path }
        });
        return;
      }

      if (this.liked) {
        this.unlikePost();
      } else {
        this.likePost();
      }
    },

    likePost: function() {
      if (!this.post) {
        return;
      }

      Post.like(this.post.objectId)
        .then(() => {
          this.$emit("liked");
        })
        .catch(err => {});
    },

    unlikePost: function() {
      if (!this.post) {
        return;
      }

      Post.unlike(this.post.objectId)
        .then(() => {
          this.$emit("unliked");
        })
        .catch(err => {});
    }
  },
  components: {},
  computed: {
    ...mapGetters(['user'])
  }
};



// WEBPACK FOOTER //
// ./src/components/PostBottomBar.vue